import { OnboardingForm } from '../types/onboardingForm'

export const getDefaultValues = (predefinedValues?: Partial<OnboardingForm>): OnboardingForm => {
  return {
    accountingManagement: predefinedValues?.accountingManagement,
    company: predefinedValues?.company || { name: '' },
    companyLogo: predefinedValues?.companyLogo,
    intents: predefinedValues?.intents ?? [],
    name: predefinedValues?.name || '',
    phone: predefinedValues?.phone || '',
    receiptUrl: predefinedValues?.receiptUrl,
    workStyle: predefinedValues?.workStyle,
  }
}
